import { imu1AdSlotSizesInfinteScroll } from "@elements/Advertisement/AdsConstants";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import { AdvertisementTypeEnum } from "@src/app/types/Ads.d";

import CompanionAdvertisement from "../CompanionAdvertisement";

/**
 * BHBasePage
 * Description: The base page component for all BH pages
 * @name - name of section or page
 * @index - use when lb1 is rendered more than 1
 */
export function Imu1CompanionAdsInfiniteScroll({
  sectionName,
  index,
}: {
  sectionName?: string;
  index: number;
  stripeBackground?: boolean;
}) {
  let overrideLb1Slot = imu1AdSlotSizesInfinteScroll["desktop"];
  if (typeof window !== "undefined" && screen.width < 767) {
    overrideLb1Slot = imu1AdSlotSizesInfinteScroll["mobile"];
  }

  return (
    <div className="flex items-center justify-center w-full">
      <CompanionAdvertisement
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.IMU1,
          slot: GoogleAdsSlotFactory.imu1(sectionName),
          id: index === 1 ? `dfp-ad-imu1` : `dfp-ad-imu1-${index}`,
          rootClassName: "m-0",
          adSlotSize: overrideLb1Slot,
          pageNumber: index.toString(),
        }}
      />
    </div>
  );
}
